import { useCallback } from 'react';
import { parseResearchResponse } from '@/utils/app-idea-helpers';
import { useEdgeFunctionWithCreditHandling } from '@/hooks/errors/use-edge-function-with-credit-handling';

export const useAppIdeaResearchGeneration = () => {
  const { invokeEdgeFunction } = useEdgeFunctionWithCreditHandling();
  
  const generateResearch = useCallback(async (problemStatement: string) => {
    console.log('[AppIdeaResearch] Starting research generation for:', problemStatement);
    
    const data = await invokeEdgeFunction('research-perplexity', {
      researchType: 'App Development Research',
      researchPrompt: problemStatement,
      appName: 'App Ideas',
      functionName: 'Research Generation',
    });

    console.log('[AppIdeaResearch] Edge function response:', {
      data,
      hasContent: !!data?.content,
      contentLength: data?.content?.length,
      sourcesCount: data?.sources?.length || 0,
      relatedQuestionsCount: data?.related_questions?.length || 0
    });

    if (data.error) {
      console.error('[AppIdeaResearch] Data error:', data.error);
      throw new Error(`Research generation failed: ${data.error}`);
    }

    // Parse the research content and extract additional data
    const parsedResearch = parseResearchResponse(data.content);
    
    // Extract citations from sources
    const citations = data.sources?.map((source: any) => source.url || source) || [];
    
    // Extract related questions
    const relatedQuestions = data.related_questions || [];
    
    console.log('[AppIdeaResearch] Parsed research data:', {
      parsedResearch,
      citations,
      relatedQuestions
    });

    return {
      ...parsedResearch,
      citations,
      relatedQuestions
    };
  }, [invokeEdgeFunction]);

  return { generateResearch };
};
